/**
 * Keyboard utilities for handling keyboard events
 * This file should remain dependency-free to avoid circular dependencies
 */

export const keyCodes = {
  ENTER: 'Enter',
  SPACE: ' ',
  END: 'End',
  HOME: 'Home',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_UP: 'ArrowUp',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_DOWN: 'ArrowDown',
  TAB: 'Tab',
  ESCAPE: 'Escape',
};

/**
 * Handle keyboard events for accessibility (Enter/Space)
 * @param event - React keyboard event
 * @param action - Function to execute when Enter or Space is pressed
 * @param args - Optional arguments to pass to the action function
 * @param condition - Optional condition that must be true for the action to execute
 */
export const handleKeyDown = (
  event: React.KeyboardEvent,
  action: (...args: any[]) => void,
  args: any[] = [],
  condition = true
) => {
  if (condition && (event.key === keyCodes.ENTER || event.key === keyCodes.SPACE)) {
    event.preventDefault();
    action(...args);
  }
};
